  
document.addEventListener('DOMContentLoaded', function() {
  // Fetch cart data and display delivery details
    getCart().then(cart => {
        removeOrphanAddons();
        displayDeliveryDetails(cart.items);
    });
  
  /*function updateCartAndRefresh() {
        getCart().then(cart => {
            displayDeliveryDetails(cart.items);
        }).catch(error => {
            console.error('Error fetching cart:', error);
        });
    }*/

    //Remove extra greetign cards begin
 function removeOrphanAddons() {

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      if (!cart.items || cart.items.length === 0) return;

      const updates = {};

      cart.items.forEach(item => {

        const isAddon = item.properties?.isAddon === true ||
                        item.properties?.isAddon === "true";

        if (!isAddon) return;

        const addonMainProduct = item.properties?.mainProduct;
        const addonGroupId = item.properties?.groupId;

        // Check if matching main product exists
        const hasMatchingMain = cart.items.some(cartItem =>
          (cartItem.properties?.isAddon !== true &&
           cartItem.properties?.isAddon !== "true") &&
          cartItem.id === addonMainProduct &&
          cartItem.properties?.groupId === addonGroupId
        );

        // If no matching main product → mark for removal
        if (!hasMatchingMain) {
          updates[item.key] = 0;
        }

      });

      // If we found orphan addons, remove them
      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(() => window.location.reload());
      }

    })
    .catch(error => console.error('Addon cleanup failed:', error));
 }
    //Remove extra greetign cards end

    
    // Function to fetch cart data
    function getCart() {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => cart);
    }   

    function formatDate(dateString) {
      //const options = { day: 'numeric', month: 'short' };
    const options = { day: 'numeric', month: 'short', year: 'numeric' }; 
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', options);
  }


  //PERCODE Begin
    /*function displayDeliveryDetails(items) {
        items.forEach(item => {
           let title = item.title;
          let isAddon = item.properties?.isAddon === true;
            if (item.properties && item.properties['_Delivery Details']) {
                try {
                    const deliveryDetailsJSON = item.properties['_Delivery Details'];
                    const deliveryDetailsArray = JSON.parse(deliveryDetailsJSON);
                    // Check if deliveryDetailsArray is an array and has at least one element
                    if (Array.isArray(deliveryDetailsArray) && deliveryDetailsArray.length > 0) {
                        const deliveryDetails = deliveryDetailsArray[0]; 
                        const detailsContainer = document.getElementById('delivery-details-' + item.key);
                        const formattedDetails = `
                            <div class="delivery-header">
                                <h6>RECIPIENT DETAILS
                                    <a href="#" class="edit-link" id="edit-${item.key}">EDIT</a>
                                </h6>
                            </div>
                            <p><span style="font-weight:550;">Name:</span> ${deliveryDetails.firstname ? (deliveryDetails.firstname + ' ' + (deliveryDetails.lastname || '')) : ''}</p>            
                            <p><span style="font-weight:500;">Phone:</span> ${deliveryDetails.phonenumber || 'Not provided'} &nbsp; &nbsp;
                             <p><span style="font-weight:500;">Email:</span> ${deliveryDetails.email || 'Not provided'} &nbsp; &nbsp;
                              <span style="font-weight:500;">Delivery:</span> ${deliveryDetails.deliverydate ? formatDate(deliveryDetails.deliverydate) : ''} </p>
                            <p><span style="font-weight:500;">Address:</span> ${deliveryDetails.Company || ''}
                            &nbsp; ${deliveryDetails.address}
                            &nbsp; ${deliveryDetails.address2}
                            &nbsp; ${deliveryDetails.area}
                            &nbsp; ${deliveryDetails.city}
                            &nbsp; ${deliveryDetails.postcode}</p>            
                        `;
                        detailsContainer.innerHTML = formattedDetails;

                    } else {
                           if (!title.includes('Membership') && !title.includes('Shipping') && !isAddon) {
                               const formattedDetails = `
                                <div class="delivery-header">
                                    <h6>Recipient Details Not available
                                        <a href="#" class="edit-link" id="edit-${item.key}">ADD</a>
                                    </h6>
                                </div>                                      
                            `;
                           const detailsContainer = document.getElementById('delivery-details-' + item.key);
                            if (detailsContainer) {
                                detailsContainer.innerHTML = formattedDetails;
                            }
                        }
                    }

                } catch (e) {
                    console.error('Error parsing delivery details:', e);
                    const detailsContainer = document.getElementById('delivery-details-' + item.key);
                    detailsContainer.innerHTML = '<p>Failed to parse delivery details.</p>';
                }
            } else { 
               if (!title.includes('Membership') && !title.includes('Shipping') && !isAddon) {
               const formattedDetails = `
                            <div class="delivery-header">
                                <h6>Recipient Details Not available
                                    <a href="#" class="edit-link" id="edit-${item.key}">ADD</a>
                                </h6>
                            </div>                                      
                        `;
                const detailsContainer = document.getElementById('delivery-details-' + item.key);
                if (detailsContainer) {
                    detailsContainer.innerHTML = formattedDetails;
                }
               }
            }
        });
    }*/

    function displayDeliveryDetails(items) {
      items.forEach(item => {
      //const { title = '', properties = {} } = item;
      const { title = '',variant_title = '',properties = {} } = item; //Vishnu Message
      const isAddon = properties.isAddon === true;

      // Skip items that shouldn't show delivery details
      if (title.includes('Membership') || title.includes('Shipping') || isAddon) return;

      const detailsContainer = document.getElementById('delivery-details-' + item.key);
      if (!detailsContainer) return;

       //Vishnu Begin

     const MessageContainer = document.getElementById('Message-' + item.key);
      if (!MessageContainer) return;      

      MessageContainer.dataset.properties = JSON.stringify(properties);

     if (!variant_title.includes('Card')) {
          if (properties['Message']) {
            MessageContainer.innerHTML = `
            <div>
              <div class="delivery-header">
                ${
                  properties['Message'] === 'Customer has left card message blank'
                    ? `<h6>Click EDIT to add message to card  <a href="#" class="edit-link" id="edit-message-${item.key}" style="background-color: yellow; color: black; font-weight: bold; padding: 10px 3px;">  EDIT</a></h6>`
                    : `<div style="display: block; width: 100%;">
                        <h6 style="display: block; width: 100%; margin-bottom: 5px;">
                            MESSAGE INSIDE CARD:
                            <a href="#" class="edit-link" id="edit-message-${item.key}">EDIT</a>
                        </h6>
                        <p style="display: block; width: 100%; margin-top: 0;">
                            ${properties['Message']}
                        </p>
                    </div>`
                }
              </div>
            `;
          } else {
            MessageContainer.innerHTML = `
              <div class="delivery-header">
                 <h6>Click EDIT to add message to card  <a href="#" class="edit-link" id="edit-message-${item.key}" style="background-color: yellow; color: black; font-weight: bold; padding: 10px 3px;">  EDIT</a></h6>
              </div>
            `;
          }
      }
     
       
      //Vihnu End

      let formattedDetails = '';

      if (properties['_Delivery Details']) {
        try {
          const deliveryDetailsArray = JSON.parse(properties['_Delivery Details']);
          const deliveryDetails = Array.isArray(deliveryDetailsArray) && deliveryDetailsArray[0];

          if (deliveryDetails) {
            formattedDetails = `
              <div class="delivery-header">
                <h6>RECIPIENT DETAILS
                  <a href="#" class="edit-link" id="edit-${item.key}">EDIT</a>
                </h6>
              </div>
              <p><span style="font-weight:550;">Name:</span> ${deliveryDetails.firstname || ''} ${deliveryDetails.lastname || ''}</p>
              <p><span style="font-weight:500;">Phone:</span> ${deliveryDetails.phonenumber || 'Not provided'} &nbsp;&nbsp;
                <span style="font-weight:500;">Email:</span> ${deliveryDetails.email || 'Not provided'} &nbsp;&nbsp;
                <span style="font-weight:500;">Delivery:</span> ${deliveryDetails.deliverydate ? formatDate(deliveryDetails.deliverydate) : ''}</p>
              <p><span style="font-weight:500;">Address:</span> ${deliveryDetails.Company || ''} &nbsp;
                ${deliveryDetails.address || ''} &nbsp; ${deliveryDetails.address2 || ''} &nbsp;
                ${deliveryDetails.area || ''} &nbsp; ${deliveryDetails.city || ''} &nbsp;
                ${deliveryDetails.postcode || ''}</p>
            `;
          } else {
            formattedDetails = getAddDetailsHTML(item.key);
          }
        } catch (e) {
          console.error('Error parsing delivery details:', e);
          formattedDetails = '<p>Failed to parse delivery details.</p>';
        }
      } else {
        formattedDetails = getAddDetailsHTML(item.key);
      }

      detailsContainer.innerHTML = formattedDetails;
    });
}

  // Helper for "Add Recipient Details"
  function getAddDetailsHTML(itemKey) {
    return `
      <div class="delivery-header">
        <h6>Recipient Details Not available
          <a href="#" class="edit-link" id="edit-${itemKey}">ADD</a>
        </h6>
      </div>
    `;
  }


    //PERCODE End
//Vday Begin

/*function setDeliveryDate(selectedDate) {
    setTimeout(() => {
    if (window.DeliveryCalendar) {
      window.DeliveryCalendar.reset();
      window.DeliveryCalendar.setDate(selectedDate);
    }
  }, 50);
  
  }*/

  function setDeliveryDate(selectedDate) {
  setTimeout(() => {
    if (!window.DeliveryCalendar) return;

    // If selectedDate is null, undefined, or empty
    if (!selectedDate) {
      window.DeliveryCalendar.reset();   // refresh / reset calendar
      return;
    }

    // Otherwise set the date
    window.DeliveryCalendar.reset();
    window.DeliveryCalendar.setDate(selectedDate);

  }, 50);
}



//Vday End
  
  function fillExistingDeliverydetails(itemId){
    // Ensure modal content is loaded and available
  var modalContent = document.querySelector('#deliveryDetailsModal .modal-content');
  
  // Select the form elements within the modal content
  var firstNameInput = modalContent.querySelector('#first-name');
  var lastNameInput = modalContent.querySelector('#last-name');
  var postalCodeInput = modalContent.querySelector('#post-code');

  var phonenumberInput = modalContent.querySelector('#phone-number');
  var emailInput = modalContent.querySelector('#email');
  var addressInput = modalContent.querySelector('#address');
  var address2Input = modalContent.querySelector('#address-2');
  var cityInput = modalContent.querySelector('#city');
  var deliverydateInput = modalContent.querySelector('#deliverydate');
  var companyInput = modalContent.querySelector('#company');
  var areaInput = modalContent.querySelector('#area');
  var backNextDiv = modalContent.querySelector('.BackNextDiv'); // Select BackNextDiv
   var btnSave = modalContent.querySelector('#SaveDelivery'); 
  // Hide BackNextDiv
  if (backNextDiv) {
    backNextDiv.style.display = 'none'; 
  }

    // Display btnSave
  if (btnSave) {
    btnSave.style.display = 'block'; 
  }
  
  // Fetch the cart details
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Find the item with the matching itemId
      let item = cart.items.find(item => item.key == itemId);  
      localStorage.setItem('selectedCartItem', itemId);

       //Vday Begin
          let isvalentineproduct = false;

          const hasPixfizzProject = !!item.properties?.['_pixfizz_project_id'];

          //isvalentineproduct = hasPixfizzProject;  //Vishnu Need to remove
                   
         if (item && item.properties && item.properties['_isvalentineproduct']) {
              isvalentineproduct = item.properties['_isvalentineproduct'];
           }
            localStorage.setItem('isvalentineproduct', isvalentineproduct);
      //Vday End

      if (item && item.properties && item.properties['_Delivery Details']) {
        try {
          // Parse the delivery details from item properties
          const deliveryDetailsJSON = item.properties['_Delivery Details'];
          const deliveryDetailsArray = JSON.parse(deliveryDetailsJSON);

          // Check if deliveryDetailsArray is an array and has at least one element
          if (Array.isArray(deliveryDetailsArray) && deliveryDetailsArray.length > 0) {
            const deliveryDetails = deliveryDetailsArray[0]; 

            // Update the input fields with the delivery details
            if (firstNameInput) firstNameInput.value = deliveryDetails.firstname || '';
            if (lastNameInput) lastNameInput.value = deliveryDetails.lastname || '';
            if (postalCodeInput) postalCodeInput.value = deliveryDetails.postcode || '';

            if (phonenumberInput) phonenumberInput.value = deliveryDetails.phonenumber || '';
            if (emailInput) emailInput.value = deliveryDetails.email || '';
            if (addressInput) addressInput.value = deliveryDetails.address || '';
            if (address2Input) address2Input.value = deliveryDetails.address2 || '';
            if (cityInput) cityInput.value = deliveryDetails.city || '';
            if (deliverydateInput) deliverydateInput.value = deliveryDetails.deliverydate || '';
            if (companyInput) companyInput.value = deliveryDetails.Company || '';
            if (areaInput) areaInput.value = deliveryDetails.area || '';
            setDeliveryDate(deliveryDetails.deliverydate);  //Vday
          } 
         
        } catch (e) {
          console.error('Error parsing delivery details:', e);
        }
      }
       //Vday Begin
      else{
        firstNameInput.value = '';
        lastNameInput.value = '';
        postalCodeInput.value = '';
        phonenumberInput.value = '';
        emailInput.value = '';
        addressInput.value = '';
        address2Input.value = '';
        cityInput.value = '';
        deliverydateInput.value = '';
        companyInput.value = '';
        areaInput.Value = '';

        //Vday Begin
          let isvalentineproduct = false;

           const hasPixfizzProject = !!item.properties?.['_pixfizz_project_id'];

          //isvalentineproduct = hasPixfizzProject;  //Vishnu Need to remove
                   
          if (item && item.properties && item.properties['_isvalentineproduct']) {
              isvalentineproduct = item.properties['_isvalentineproduct'];
           }
            localStorage.setItem('isvalentineproduct', isvalentineproduct);
          //Vday End

        
        setDeliveryDate('');
      }
      //Vday End
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });

  }

    var modal = document.getElementById("deliveryDetailsModal");
  var btn = document.getElementById("openModalButton"); // Button to trigger the modal
  var span = document.getElementsByClassName("close")[0];
      
 // Handle opening the delivery details modal
    document.body.addEventListener('click', function(event) {
        if (event.target && event.target.classList.contains('edit-link')) {
            event.preventDefault();
            const editLink = event.target;
            const itemId = editLink.id.replace('edit-', '');

            if (itemId) {
                fillExistingDeliverydetails(itemId);
                modal.style.display = "block";
            }
        }
    });

  // Close modal functionality
  const closeButton = document.querySelector('.modal .close');
  if (closeButton) {
      closeButton.addEventListener('click', function() {
        document.getElementById('deliveryDetailsModal').style.display = 'none';
      });
  }

 // Close modal if clicked outside of modal content
window.addEventListener('click', function(event) {
  if (closeButton) {
    if (event.target === document.getElementById('deliveryDetailsModal')) {
      document.getElementById('deliveryDetailsModal').style.display = 'none';
    }
  }
});  

 // Select the checkout button by its class name
const checkoutButton = document.querySelector('.checkout__button');

// Add the click event listener to the checkout button
checkoutButton.addEventListener('click', async function(event) {
    event.preventDefault(); // Prevent the default checkout action

    const requiredTag = 'gold-membership';
    const tags = window.customerTags || [];
    let shouldRedirectToCheckout = true; // Flag to determine whether to redirect to /checkout

    //console.log('Customer Tags:', tags);

    // If the customer does not have the required membership, check and add it
    if (!tags.includes(requiredTag)) {
        console.log('Customer does not have the required membership tag. Checking if membership needs to be added...');
        try {
            await checkAndAddMembershipProduct();
        } catch (error) {
            // If there's an issue adding membership, the user is redirected to /account
            alert(error.message || 'There was an issue adding the membership.');
            return; // Exit here, do not proceed to checkout
        }
    } else {
        console.log('Customer already has the required membership.');
    }

    // Proceed only after the membership check is completed (or if membership is already in the cart)
    try {
        const message = await CheckallHaveaddress();
        console.log('Address check passed:', message);

        // Vishnu User clicked Cancel
        if (message === false) {
            if (missingMessageItemKey) {
            document
                .getElementById(`edit-message-${missingMessageItemKey}`)
                ?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
        }

            return;
        }
        //Vishnu Message end
        if (shouldRedirectToCheckout) {
            console.log('Redirecting to /checkout...');
            window.location.href = '/checkout'; // Proceed to checkout if everything is fine
        }
    } catch (error) {
        console.log('Address check failed:', error.message);
        alert(error.message || 'Please complete all delivery details.');
    }
});


function checkAndAddMembershipProduct() {
    return new Promise((resolve, reject) => {
        const membershipProductVariantId = 48947517129006; 
        const sellingPlanId = 690805113134; 

        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                //console.log('Current Cart:', cart);

                const alreadyInCart = cart.items.some(item =>
                    item.variant_id === membershipProductVariantId 
                    //&& item.selling_plan_allocation &&
                    //item.selling_plan_allocation.selling_plan_id === sellingPlanId
                );

                if (alreadyInCart) {
                    console.log('Membership subscription is already in the cart.');
                    resolve();
                } else {
                    console.log('Adding membership subscription to the cart...');

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: membershipProductVariantId,
                            quantity: 1,
                            selling_plan: sellingPlanId
                        })
                    })
                    .then(res => {
                        if (!res.ok) {
                            throw new Error('Failed to add product to cart');
                        }
                        return res.json();
                    })
                    .then(data => {
                        console.log('Successfully added membership subscription:', data);
                        resolve();
                    })
                    .catch(error => {
                        console.error('Error adding membership subscription:', error);
                        reject(error);
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching cart:', error);
                reject(error);
            });
    });
}

  
/***********************************
 * CONFIG
 ***********************************/
const dailyCutoffTimes = {
    Monday: '16:14',
    Tuesday: '16:14',
    Wednesday: '16:14',
    Thursday: '16:14',
    Friday: '16:14',
    Saturday: '11:44',
    Sunday: '11:44'
};


/***********************************
 * CORE UK TIMEZONE ENGINE
 ***********************************/

// Convert any JS Date → true UK date/time (DST-safe)
function getLondonDate(date = new Date()) {
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
    }).formatToParts(date);

    const get = t => parts.find(p => p.type === t)?.value;

    // Build a date that represents the UK wall clock time
    return new Date(
        `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`
    );
}


// Create a UK date at midnight (DST-safe)
function makeUKMidnight(year, monthIndex, day) {
    // 1) Start at UTC noon → guaranteed to exist in UK time (avoids DST gaps)
    const utcNoon = new Date(Date.UTC(year, monthIndex, day, 12, 0, 0));

    // 2) Convert noon → UK time
    const ukDate = getLondonDate(utcNoon);

    // 3) Snap to UK midnight
    ukDate.setHours(0, 0, 0, 0);

    return ukDate;
}


// Add whole days in UK timezone safely
function addUKDays(ukDate, days) {
    const tmp = new Date(ukDate);
    tmp.setDate(tmp.getDate() + days);
    return makeUKMidnight(tmp.getFullYear(), tmp.getMonth(), tmp.getDate());
}


/***********************************
 * COMPARISON HELPERS
 ***********************************/

// True "start of UK day"
function startOfUKDay(ukDate) {
    return makeUKMidnight(
        ukDate.getFullYear(),
        ukDate.getMonth(),
        ukDate.getDate()
    );
}

// Compare if two UK dates are the same day
function isSameUKDay(a, b) {
    return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
    );
}

// Returns UK weekday name
const DAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
function ukDayName(ukDate) {
    return DAY_NAMES[ukDate.getDay()];
}


/***********************************
 * CUTOFF LOGIC
 ***********************************/
function hasPassedCutoff(currentUK, cutoffStr) {
    const [hh, mm] = cutoffStr.split(':').map(Number);

    const cutoff = new Date(currentUK);
    cutoff.setHours(hh, mm, 0, 0);

    return currentUK > cutoff;
}


/***********************************
 * PARSER — TEXT → UK MIDNIGHT DATE
 ***********************************/
function parseDeliveryDateToUKMidnight(dateStr, fallbackYear) {
    if (!dateStr) return null;

    const s = dateStr.trim().toLowerCase();

    // 1) YYYY-MM-DD
    let m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return makeUKMidnight(+m[1], +m[2] - 1, +m[3]);

    // 2) DD/MM/YYYY or DD-MM-YYYY
    m = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
    if (m) return makeUKMidnight(+m[3], +m[2] - 1, +m[1]);

    // 3) “20 August” or “20 August 2025”
    const months = {
        january:1,february:2,march:3,april:4,may:5,june:6,
        july:7,august:8,september:9,october:10,november:11,december:12
    };

    m = s.match(/^(\d{1,2})\s+([a-z]+)(?:\s+(\d{4}))?$/);
    if (m && months[m[2]]) {
        const year = m[3] ? +m[3] : fallbackYear;
        return makeUKMidnight(year, months[m[2]] - 1, +m[1]);
    }

    // Fallback: invalid string
    return null;
}


/***********************************
 * UK DATE FORMATTER
 ***********************************/
function formatUKDate(ukDate) {
    const d = String(ukDate.getDate()).padStart(2, '0');
    const m = String(ukDate.getMonth() + 1).padStart(2, '0');
    const y = ukDate.getFullYear();
    return `${d}/${m}/${y}`;
}
  
/*const holidays = [
        '2025-04-18','2025-04-19','2025-04-20','2025-04-21',
        '2025-05-04','2025-05-05','2025-05-25','2025-05-26',
        '2025-08-24','2025-08-25','2025-08-26',
        '2025-12-20','2025-12-21','2025-12-22','2025-12-23','2025-12-24',
        '2025-12-25','2025-12-26','2025-12-27',
        '2025-12-28','2025-12-29','2026-01-01','2026-01-02',   
        '2026-02-01','2026-02-02','2026-02-03','2026-02-04','2026-02-05','2026-02-06','2026-02-07','2026-02-08',
        '2026-02-09','2026-02-10','2026-02-11','2026-02-12','2026-02-13','2026-02-14','2026-02-15','2026-03-10','2026-03-11','2026-03-12','2026-03-13',
        '2026-03-14','2026-03-15','2026-03-16','2026-03-17','2026-03-18','2026-03-19','2026-03-20'
    ];*/

function isHoliday(deliveryDateStr,isvalentineproduct) {
  if (!deliveryDateStr) return false;

  // Convert "23 December 2025" → "2025-12-23"
  const parsedDate = new Date(deliveryDateStr);
  if (isNaN(parsedDate)) return false;

  const y = parsedDate.getFullYear();
  const m = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const d = String(parsedDate.getDate()).padStart(2, '0');

  const formatted = `${y}-${m}-${d}`;

  //Vday Begin
        let holidays = [];
        
     /*  if (isvalentineproduct === true || isvalentineproduct === 'true') {

         holidays = [ 
             '2026-10-04','2026-10-10','2026-10-11','2026-12-25','2026-12-26','2026-12-27','2026-12-29','2027-01-01','2027-01-02','2027-03-26','2027-03-27','2027-03-28','2027-03-30','2027-05-04','2027-06-01'
        ];
       
      /*holidays = [];

        const start = new Date('2026-05-12');
        const end   = new Date('2027-05-31'); // calendar shows till Feb end

        for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {

            const isMar2026 =
                d.getFullYear() === 2026 &&
                (d.getMonth() === 4 || d.getMonth() === 5);

            const day = d.getDate();

            // Enable only March 9–15, 2026
            if (isMar2026 && day >= 28 && day <= 30) continue;
            //if (isMar2026 && day <= 12) continue;

            //if (isMar2026 && day === 26) continue;

            holidays.push(d.toISOString().slice(0, 10)); 
        }
        // Disable May 26, 2026 specifically
         holidays.push('2026-05-12');
          holidays.push('2026-05-13');
        holidays.push('2026-05-26');
    } */

      if (isvalentineproduct === true || isvalentineproduct === 'true') 
    {

    // Disable all dates before December 1 and after December 31
    const start = new Date(2026, 11, 1);
    const end = new Date(2026, 11, 31);

    // Add unavailable dates before December
    for (let d = new Date(2026, 0, 1); d < start; d.setDate(d.getDate() + 1)) {
        holidays.push(
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
        );
    }

    // Add unavailable dates after December
    for (let d = new Date(2027, 0, 1); d <= new Date(2027, 11, 31); d.setDate(d.getDate() + 1)) {
        holidays.push(
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
        );
    }

    // Disable specific December dates
    holidays.push('2026-12-01');
    holidays.push('2026-12-25');
    holidays.push('2026-12-26');
    holidays.push('2026-12-27');
    holidays.push('2026-12-29');
    holidays.push('2026-12-30');
    holidays.push('2026-12-31');

}    
    else {
        holidays = [            
          '2026-09-01','2026-10-02','2026-10-03','2026-10-04','2026-12-25','2026-12-26','2026-12-27','2026-12-29','2027-01-01','2027-01-02','2027-03-26','2027-03-27','2027-03-28','2027-03-30','2027-05-04','2027-06-01'
        ];
    }

    //Vday End
  
  return holidays.includes(formatted);
}


function CheckallHaveaddress() {
  return new Promise((resolve, reject) => {
    let cntNoDeliveryDetails = 0;
    let totalCart = 0;

    let totalMessage = 0;
    let cntMessage = 0;

    getCart()
      .then(cart => {
        const nowUK = getLondonDate();
        const todayUK = startOfUKDay(nowUK);
        const todayName = ukDayName(todayUK);
        const cutoffStr = dailyCutoffTimes[todayName];

        for (const item of cart.items) {
          const title = item.title;
          const isAddon = item.properties?.isAddon === true;

          // Check if Pixfizz project ID exists
          const hasPixfizzProject =
            item.properties?.['_pixfizz_project_id'];

          // Vday Begin
          let isvalentineproduct = false;
          //isvalentineproduct = !!hasPixfizzProject;  //Vishnu Need to remove
         if (item?.properties?._isvalentineproduct) {
            isvalentineproduct =
              item.properties._isvalentineproduct;
          }
          // Vday End


          // ==========================================
          // Card Message Check
          // ==========================================

          if (
            !title.includes('Membership') &&
            !title.includes('Shipping') &&
            !isAddon &&
            !hasPixfizzProject
          ) {
            totalMessage++;

            const message =
              item.properties?.['Message']?.trim();

            if (
              message &&
              message.toLowerCase() !==
                'customer has left card message blank'
            ) {
              cntMessage++;
            }
            else {
              missingMessageItemKey = item.key;
            }
          }


          // ==========================================
          // Delivery Details Check
          // ==========================================

          if (
            !title.includes('Membership') &&
            !title.includes('Shipping') &&
            !isAddon
          ) {
            totalCart++;

            const ddRaw =
              item.properties?.['_Delivery Details'];

            if (!ddRaw) {
              continue;
            }

            let deliveryDetailsArray;

            try {
              deliveryDetailsArray =
                JSON.parse(ddRaw);
            } catch (error) {
              alert(
                `Invalid delivery details format for "${title}".`
              );

              return reject(error);
            }


            if (
              Array.isArray(deliveryDetailsArray) &&
              deliveryDetailsArray.length > 0
            ) {
              cntNoDeliveryDetails++;

              const deliveryDateStr =
                deliveryDetailsArray[0]?.deliverydate;


              // ==========================================
              // Holiday Check
              // ==========================================

              if (
                isHoliday(
                  deliveryDateStr,
                  isvalentineproduct
                )
              ) {
                alert(
                  `Delivery not allowed on ${deliveryDateStr}. Please select an available date for "${title}".`
                );

                return reject(
                  //new Error('Holiday delivery')
                );
              }


              // ==========================================
              // Parse Delivery Date
              // ==========================================

              const deliveryDateOnly =
                parseDeliveryDateToUKMidnight(
                  deliveryDateStr,
                  nowUK.getUTCFullYear()
                );

              if (!deliveryDateOnly) {
                alert(
                  `Invalid delivery date for "${title}": ${deliveryDateStr}`
                );

                return reject(
                  new Error('Invalid delivery date')
                );
              }


              // ==========================================
              // Same-Day Delivery Check
              // ==========================================

              if (
                isSameUKDay(
                  deliveryDateOnly,
                  todayUK
                )
              ) {
                alert(
                  `Same-day delivery is not allowed for "${title}". Please select a later delivery date.`
                );

                return reject(
                  new Error('Same-day delivery')
                );
              }


              // ==========================================
              // Cutoff Logic
              // ==========================================

              const tomorrowUK =
                addUKDays(todayUK, 1);

              const dayAfterTomorrowUK =
                addUKDays(todayUK, 2);


              if (
                hasPassedCutoff(
                  nowUK,
                  cutoffStr
                )
              ) {
                if (
                  deliveryDateOnly <
                  dayAfterTomorrowUK
                ) {
                  alert(
                    `Cutoff passed. "${title}" must be delivered from ${formatUKDate(dayAfterTomorrowUK)} onwards.`
                  );

                  return reject(
                    new Error('Cutoff passed')
                  );
                }
              } else {
                if (
                  deliveryDateOnly <
                  tomorrowUK
                ) {
                  alert(
                    `"${title}" must be delivered from ${formatUKDate(tomorrowUK)} onwards.`
                  );

                  return reject(
                    new Error('Invalid delivery date')
                  );
                }
              }
            }
          }
        }


        // ==========================================
        // Check Delivery Details
        // ==========================================

        if (cntNoDeliveryDetails !== totalCart) {
          alert(
            'Please add delivery details to all items before proceeding.'
          );
          return reject();
          /*return reject(
            new Error('Missing delivery details')
          );*/
        }


        // ==========================================
        // Check Card Messages
        // ==========================================

        if (cntMessage !== totalMessage) {
          const proceed = confirm(
            'Message inside the card is blank.\n\n' +
            'Do you want us to proceed anyway?'
          );

          // User clicked Cancel
          if (!proceed) {
            resolve(false);
            return;
          }
        }


        // ==========================================
        // Everything is valid
        // ==========================================

        resolve(true);
      })
      .catch(err => {
        console.error(
          'Error getting cart:',
          err
        );

        reject(err);
      });
  });
}

/*function CheckallHaveaddress() {
  return new Promise((resolve, reject) => {
    let cntNoDeliveryDetails = 0;
    let totalCart = 0;

    getCart().then(cart => {
      const nowUK = getLondonDate();
      const todayUK = startOfUKDay(nowUK);
      const todayName = ukDayName(todayUK);
      const cutoffStr = dailyCutoffTimes[todayName];

      for (const item of cart.items) {
        const title = item.title;
        const isAddon = item.properties?.isAddon === true;

        //Vday Begin
        let isvalentineproduct = false;
        if (item && item.properties && item.properties['_isvalentineproduct']) {
              isvalentineproduct = item.properties['_isvalentineproduct'];
        }
        //Vday End

        if (!title.includes('Membership') && !title.includes('Shipping') && !isAddon) {
          totalCart++;

          const ddRaw = item.properties?.['_Delivery Details'];

          //alert(item.properties?.['_Delivery Details']);  //Vishnu
          if (!ddRaw) continue;

          let deliveryDetailsArray;
          try {
            deliveryDetailsArray = JSON.parse(ddRaw);
          } catch {
            alert(`Invalid delivery details format for "${title}".`);
            return reject();
          }

          if (Array.isArray(deliveryDetailsArray) && deliveryDetailsArray.length > 0) {
            cntNoDeliveryDetails++;

          const deliveryDateStr = deliveryDetailsArray[0]?.deliverydate;

          // ✅ Holiday check (new logic only)
          if (isHoliday(deliveryDateStr,isvalentineproduct)) {
            alert(`Delivery not allowed on ${deliveryDateStr}. Please select an available date for "${title}".`);
            return reject();
          }

           const deliveryDateOnly = parseDeliveryDateToUKMidnight(deliveryDateStr, nowUK.getUTCFullYear());
            if (!deliveryDateOnly) {
              alert(`Invalid delivery date for "${title}": ${deliveryDateStr}`);
              return reject();
            }

            // 1) Block same-day
            if (isSameUKDay(deliveryDateOnly, todayUK)) {
              alert(`Same-day delivery is not allowed for "${title}". Please select a later delivery date.`);
              return reject();
            }


            // 2) Cutoff logic
            const tomorrowUK = addUKDays(todayUK, 1);
            const dayAfterTomorrowUK = addUKDays(todayUK, 2);

            if (hasPassedCutoff(nowUK, cutoffStr)) {
              if (deliveryDateOnly < dayAfterTomorrowUK) {
                alert(`Cutoff passed. "${title}" must be delivered from ${formatUKDate(dayAfterTomorrowUK)} onwards.`);
                return reject();
              }
            } else {
              if (deliveryDateOnly < tomorrowUK) {
                alert(`"${title}" must be delivered from ${formatUKDate(tomorrowUK)} onwards.`);
                return reject();
              }
            }
          }
        }
      }

      if (cntNoDeliveryDetails !== totalCart) {
        alert('Please add delivery details to all items before proceeding.');
        reject();
      } else {
        resolve('All items valid');
      }
    }).catch(err => {
      console.error("Error getting cart:", err);
      reject();
    });
  });
} */


});